import React from 'react';
import { Button, Result } from 'antd';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { useHistory } from 'react-router-dom';

const Authorized = () => {
  const { t } = useTranslation();
  const history = useHistory();
  return (
    <Result
      status="403"
      subTitle={t('notAuthorized')}
      extra={
        <Button onClick={() => history.push('/dashboard')} type="primary">
          Anasayfa
        </Button>
      }
    />
  );
};

export default connect()(Authorized);
